import { useState } from 'react';
import AdminLayout from '../layouts/AdminLayout';
import ViewOrder from './ViewOrder';

// Definimos el tipo de las pestañas disponibles en el AdminLayout
type TabId = 'dashboard' | 'products' | 'categories' | 'collections' | 'catalogs' | 'sliders' | 'users' | 'orders' | 'settings';

export default function AdminOrderView() {
  const [activeTab, setActiveTab] = useState<TabId>('orders');
  
  return (
    <AdminLayout activeTab={activeTab} onTabChange={setActiveTab}>
      <ViewOrder isClientView={false} />
    </AdminLayout>
  );
} 